const rhythm = (baseLineHeight, n = 1) => {
  return `${baseLineHeight * n}rem`;
};

export { rhythm };
